import { useTranslation } from 'react-i18next'

import { LandingDemoPlayer } from '@/features/demos/LandingDemoPlayer'
import { VoiceDemoModalTrigger } from '@/features/demos/VoiceDemoModalTrigger'

import { seoKeywordI18nPrefix } from './catalog'

const STEPS = [
    {
        key: 1,
        image: '/app-escandallos/app-albaran-subido.webp',
        imageAltKey: 'steps.1.imageAlt',
        width: 640,
        height: 1408,
    },
    {
        key: 2,
        image: '/app-escandallos/app-recetario-mic-activo.webp',
        imageAltKey: 'steps.2.imageAlt',
        width: 644,
        height: 1404,
    },
    {
        key: 3,
        image: '/app-escandallos/app-ingredientes-subidas.webp',
        imageAltKey: 'steps.3.imageAlt',
        width: 648,
        height: 1410,
    },
    {
        key: 4,
        image: '/app-escandallos/app-plato-en-perdidas.webp',
        imageAltKey: 'steps.4.imageAlt',
        width: 636,
        height: 1414,
    },
    {
        key: 5,
        image: '/app-escandallos/app-finanzas-beneficio.webp',
        imageAltKey: 'steps.5.imageAlt',
        width: 650,
        height: 1410,
    },
] as const

export function AppEscandallosTimelineSection() {
    const { t } = useTranslation()
    const prefix = seoKeywordI18nPrefix('app-escandallos')

    return (
        <section className='bg-[#F5EEE4] px-[22px] py-14 md:px-10 md:py-20'>
            <div className='mx-auto flex w-full max-w-[1180px] flex-col'>
                <div className='mb-9 flex flex-col gap-2'>
                    <div className='text-xs font-semibold uppercase tracking-[2px] text-[#F4502A]'>
                        {t(`${prefix}.timeline.eyebrow`)}
                    </div>
                    <h2 className='m-0 text-balance text-[30px] font-medium leading-[1.15] tracking-[-1px] text-[#17130E] md:text-[40px]'>
                        {t(`${prefix}.timeline.title`)}
                    </h2>
                    <p className='m-0 text-[15px] leading-[1.6] text-[#5C5548] md:text-base'>
                        {t(`${prefix}.timeline.subtitle`)}
                    </p>
                </div>

                <div className='mb-9'>
                    <LandingDemoPlayer demoId='product-tour' />
                </div>

                <ol className='m-0 flex list-none flex-col p-0'>
                    {STEPS.map((step, index) => {
                        const isLast = index === STEPS.length - 1
                        return (
                            <li key={step.key} className='flex gap-4'>
                                <div className='flex w-9 shrink-0 flex-col items-center'>
                                    <div className='flex size-9 shrink-0 items-center justify-center rounded-full border-[1.5px] border-[#F4502A] bg-[rgba(244,80,42,0.1)] text-sm font-extrabold text-[#F4502A]'>
                                        {step.key}
                                    </div>
                                    {!isLast ? (
                                        <div className='mt-2 w-px flex-1 bg-[rgba(23,19,14,0.15)]' aria-hidden />
                                    ) : null}
                                </div>
                                <div className={`flex min-w-0 flex-1 flex-col gap-3.5 ${isLast ? '' : 'pb-9'}`}>
                                    <div className='flex flex-col gap-1'>
                                        <div className='text-[17px] font-bold text-[#17130E] md:text-lg'>
                                            {t(`${prefix}.steps.${step.key}.title`)}
                                        </div>
                                        <div className='text-sm leading-[1.55] text-[#5C5548] md:text-[15px]'>
                                            {t(`${prefix}.steps.${step.key}.description`)}
                                        </div>
                                        {step.key === 2 ? (
                                            <VoiceDemoModalTrigger landingPage='app-escandallos' className='mt-2' />
                                        ) : null}
                                    </div>
                                    <img
                                        src={step.image}
                                        alt={t(`${prefix}.${step.imageAltKey}`)}
                                        width={step.width}
                                        height={step.height}
                                        className='block h-auto w-full max-w-[220px] rounded-[20px] border border-[#E2D9CB] shadow-[0_12px_28px_rgba(23,19,14,0.18)] md:max-w-[260px]'
                                        loading='lazy'
                                        decoding='async'
                                    />
                                </div>
                            </li>
                        )
                    })}
                </ol>
            </div>
        </section>
    )
}
